import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	addIssueType: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	editIssueType: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	manageIssueTypes: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	addIssueType: {
		id: 'issue-field-issue-type-editview-full.issue-type.add-work-type',
		defaultMessage: 'Add work type',
		description: 'Footer item in dropdown to add a new work type inline',
	},
	editIssueType: {
		id: 'issue-field-issue-type-editview-full.issue-type.edit-work-type',
		defaultMessage: 'Edit work type',
		description: 'Footer item in dropdown to edit a work type inline',
	},
	manageIssueTypes: {
		id: 'issue-field-issue-type-editview-full.issue-type.manage-work-types',
		defaultMessage: 'Manage',
		description: 'Footer item in dropdown to manage work types',
	},
});
export default messages;
